const local = {

    en:{
       title: 'LOGIN - CONDTROL WARRANTY SERVICE',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',
   
    form_ttl:"LOGIN",
    username:"login or e-mail",
    password:"Password",
    precovery:"Password recovery",
    sbmt:"LOGIN",

    },

    ru:{
       title: 'ВХОД - CONDTROL РАСШИРЕННАЯ ГАРАНТИЯ',
 description: 'регистрация продуктов CONDTROL',
    keywords: 'регистрация, продление гарантии',
   

    form_ttl:"ВХОД",
    username:"Логин или e-mail",
    password:"Пароль",
    precovery:"Забыли пароль?",
    sbmt:"ВОЙТИ",

    },

    de:{
       title: 'CONDTROL WARRANTY SERVICE',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',

    form_ttl:"Login",
    username:"login or e-mail",
    password:"Password",
    precovery:"Password recovery",
    sbmt:"Senden",

    },

};

export default local;